module.exports = __webpack_public_path__ + "static/media/crocodile(13).ad38ea4e.PNG";